import Lottie from "lottie-react";
import processingAnimation from "./lottie/processingAnimation.json";
import styled from "styled-components";
import { Text } from "src/apps/components/typography/Texts";
import { T } from "src/apps/components/i18n/Translation";
import { FadeInAnimation } from "src/apps/components/fadeIn/FadeInAnimation";

export const IdentityVerificationProcessingState = () => {
  return (
    <FadeInAnimation>
      <Container>
        <LottieContainer>
          <Lottie animationData={processingAnimation} />
        </LottieContainer>
        <Text>
          <T k="documentation_area.identity_verification.processing.text" />
        </Text>
      </Container>
    </FadeInAnimation>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  height: 31.25rem;
`;

const LottieContainer = styled.div`
  height: 3.75rem;
  aspect-ratio: 1;
`;
